import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CookieConsentService } from '../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.css'
})
export class CookieConsentComponent {
  readonly consent = inject(CookieConsentService);

  acceptAll(): void {
    this.consent.acceptAll();
  }

  acceptNecessaryOnly(): void {
    this.consent.acceptNecessaryOnly();
  }
}
